/**
 * Strips the alpha channel from `#RRGGBBAA` / `#RGBA` hex colors.
 *
 * Zone fills historically defaulted to `#3B82F620` — alpha baked into the
 * color — while `fillOpacity` was applied on top. The two multiplied
 * (0.125 × 0.12 ≈ 0.015), making fills nearly invisible. Opacity is owned
 * by `fillOpacity` alone; colors are normalized to their opaque form.
 */
export const stripHexAlpha = (color: string): string => {
  if (/^#[0-9a-fA-F]{8}$/.test(color)) return color.slice(0, 7);
  if (/^#[0-9a-fA-F]{4}$/.test(color)) return color.slice(0, 4);
  return color;
};
